import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import TaskCard from "./TaskCard";

const TaskProcess = () => {
  const [taskData, setTaskData] = useState([]);
  
  useEffect(() => {
    axios.get("https://your-api-url.com/tasks") // ❗ API URL Change பண்ணு
      .then((response) => {
        setTaskData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching tasks:", error);
      });
  }, []);

  const categories = ["Overdue", "Open", "Progress", "Completed"];

  return (
    <Container>
      <Row>
        {categories.map((category) => (
          <Col key={category}>
            <h5>{category}</h5>
            {taskData
              .filter((task) => task.status.toLowerCase() === category.toLowerCase())
              .map((task) => (
                <TaskCard key={task.id} task={task} />
              ))}
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default TaskProcess;
